<template>
    <div class="edc-modal">
        <SOSlotModal :modal-title="`Konfirmasi`" :modal-id="modalId" @close="back">
            <template v-slot:modal-body>
                <div>
                    <p class="m-d-8 f-16 f-c-black f-regular">
                        Anda yakin ingin menghapus?
                    </p>
                </div>
            </template>
            <template v-slot:modal-footer>
                <div class="">
                    <div style="margin-bottom: 10px">
                        <SOButton
                            :outline-danger="true"
                            :full="true"
                            :text="'Ya, hapus setoran'"
                            :id="`delete-setoran`"
                            :disable="isFetching"
                            :loading="isFetching"
                            @action="doDelete"
                        />
                    </div>
                    <div>
                        <SOButton
                            :outline="true"
                            :full="true"
                            :text="'Batal'"
                            :id="'batal-delete-setoran'"
                            :disable="isFetching"
                            :loading="isFetching"
                            @action="back"
                        />
                    </div>
                </div>
            </template>
        </SOSlotModal>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

import SOSlotModal from "@/so-components/global/slot/SOSlotModal.vue";
import SOButton from "@/so-components/global/ui/SOButton";

export default {
    name: "ConfirmDelete",
    components: {
        SOSlotModal,
        SOButton,
    },
    data() {
        return {
            modalId: "confirm-delete",
            isFetching: false,
        };
    },
    beforeRouteLeave(to, from, next) {
        this.closeModal();
        next();
    },
    mounted() {
        $(`#${this.modalId}`).modal("show");
    },
    computed: {
        getDataId() {
            return this.$route.params.id;
        },
    },
    methods: {
        ...mapActions({
            removeDevice: `setoranKasWorkshopModule/deleteData`,
        }),
        async back() {
            await this.$router.back();
        },
        closeModal() {
            $(`#${this.modalId}`).modal("hide");
        },
        setFetching(val) {
            this.isFetching = val;
        },
        doDelete() {
            if (this.isFetching) {
                return;
            }
            this.setFetching(true);
            this.removeDevice({ idtransfer: this.$route.params.id })
                .then((res) => {
                    if (!res.data) {
                        this.$toast.error(res);
                    } else {
                        let { code, data, msg, status } = res.data;
                        if (code === 200 && status) {
                            this.$toast.success(msg);
                            this.flushData();
                        }
                    }
                    this.setFetching(false);
                })
                .catch((e) => {
                    this.setFetching(false);
                    this.$toast.error(e);
                });
        },
        async flushData() {
            await this.$store.commit("setoranKasWorkshopModule/resetSetoranKasWorkshop");
            await this.$store.commit("setoranKasWorkshopModule/resetPagination");
            await this.$store.commit("setoranKasWorkshopModule/resetSearch");
            await this.$store.commit("setoranKasWorkshopModule/setIsSearch", false);
            await this.$router.go(-2);
        },
    },
};
</script>
